import { getUserModuleState, UserState } from "#login/store/reducers";
import { createSelector } from "@ngrx/store";
import * as loginFormReducers from "#login/store/reducers/login-form.reducer";

export const getUserState = createSelector(
    getUserModuleState,
    (state: UserState) => state.login
);

export const getLoginBannerStatus = createSelector(
    getUserState,
    loginFormReducers.getLoginBannerStatus
);

export const getLoginBannerMessage = createSelector(
    getUserState,
    loginFormReducers.getLoginBannerMessage
);

export const getLoginBannerColor = createSelector(
    getUserState,
    loginFormReducers.getLoginBannerColor
);

export const  getSampleCenterOAuthSuccess = createSelector(
    getUserState,
    loginFormReducers.getSampleCenterOAuthSuccess
);
